import VideoConstructor from '@scripts/video';

window.addEventListener('load', () => {

  const pageContainer = document.querySelector('.page');
  const Header = document.querySelector('header.header');
  const gradient = document.getElementById('paint_linear');

  let offset = 0;
  let animationFrame;
  let isAnimating = false;
  let scrollTimeout;

  function animateGradient() {
    offset -= 3; // скорость
    if (offset <= -360) offset = 0;
    gradient.setAttribute('gradientTransform', `rotate(${offset})`);

    if (isAnimating) {
      animationFrame = requestAnimationFrame(animateGradient);
    }
  }

  if (!pageContainer || !Header) return;

  window.addEventListener('scroll', function() {
    console.log("onscroll", Header);
    // Добавляем класс при начале скролла
    Header.classList.add('scrolling');

    if (!isAnimating) {
      isAnimating = true;
      animateGradient();
    }

    // Очищаем предыдущий таймаут
    clearTimeout(scrollTimeout);

    // Убираем класс через 150мс после остановки скролла
    scrollTimeout = setTimeout(() => {
      Header.classList.remove('scrolling');
      isAnimating = false;
      cancelAnimationFrame(animationFrame);
    }, 200);

  });

  // Video constructor
  const videos = document?.querySelectorAll('video')
  videos.forEach(video => {
    VideoConstructor(video)
  })

  const Burger = document.querySelector('.btn-burger');
  Burger.onclick = () => {
    Burger.classList.toggle('active');
  }

  function animateSVGLine (line) {
      let trace = line.querySelector("path")
      if (trace) {
        let traceLength = Math.round(trace.getTotalLength())
        trace.style.strokeDasharray = `${traceLength}`
        trace.style.strokeDashoffset = `${traceLength}`
        setTimeout(() => {
          if (trace) {
            trace.style.strokeDashoffset = `0`
            trace.classList.add('animate')
          }
        }, 300)
      }
  }

  // Создаём наблюдатель для SVG
  const svgObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const svg = entry.target;

        // Запускаем анимацию для этого SVG
        animateSVGLine(svg);

        // Отключаем наблюдение за этим SVG
        svgObserver.unobserve(svg);
      }
    });
  }, {
    threshold: 0.8 // Появляется при видимости 30%
  });

  // Наблюдаем за каждым SVG с классом svg-animate
  document.querySelectorAll('svg.svg-animate').forEach(svg => {
    svgObserver.observe(svg);
  });


  // Функция для последовательного показа элементов одного списка
  function showItemsSequentially(container) {
    const containerDelay = container.dataset.cdelay ? container.dataset.cdelay : 0;
    const delay = container.dataset.delay ? container.dataset.delay : 600;
    const items = container.querySelectorAll('.fade-item');
    setTimeout(() => {
      items.forEach((item, index) => {
        setTimeout(() => {
          item.classList.toggle('show');
        }, index * delay);
      });
    }, containerDelay)
  }

  // Создаём наблюдатель
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Если элемент появился в зоне видимости
      if (entry.isIntersecting) {
        const container = entry.target;

        // Показываем элементы этого списка
        showItemsSequentially(container);

        // Отключаем наблюдение за этим контейнером
        observer.unobserve(container);
      }
    });
  }, {
    threshold: 0.5 // Элемент считается видимым, когда видно 50%
  });

  // Наблюдаем за каждым контейнером списка
  document.querySelectorAll('.list-container').forEach(container => {
    observer.observe(container);
  });


// Получаем все кнопки вопросов
  const faqQuestions = document.querySelectorAll('.faq__question[role="button"]');

// Добавляем обработчик клика на каждый вопрос
  faqQuestions.forEach(question => {
    question.addEventListener('click', function(event) {
      // Находим родительский элемент li
      const parentItem = this.closest('.faq__list-item');

      // Проверяем, есть ли у элемента класс show
      if (parentItem.classList.contains('show')) {
        // Если есть - убираем (закрываем)
        parentItem.classList.remove('show');
      } else {
        // Если нет - добавляем (открываем)
        parentItem.classList.add('show');
      }
    });

    // Добавляем поддержку клавиши Enter для доступности
    question.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.click();
      }
    });
  });
})
